import React from 'react';
import HeroText from './HeroText';
import MissionSection from './MissionSection';
import SolutionsSection from './SolutionsSection';
import OptimizedBackground from './OptimizedBackground';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="homepage-container">
      <OptimizedBackground
        imageUrl="/BG.png"
        className="hero-section-wrapper"
      >
        <HeroText />
      </OptimizedBackground>
      <MissionSection />
      <SolutionsSection />
    </div>
  );
}

export default LandingPage;
